module.exports = __webpack_public_path__ + "img/2.9a62654c.jpg";